// Helpers for the Iconify-based icon picker (shared logic, no DOM/network side effects).
// The API address, the sets and the JSON-to-svg step live in editor-v2/utils/iconSvg.js:
// the canvas resolves the AI tab's icon names with them (ONE implementation).
import { ICON_SETS } from '@/editor-v2/utils/iconSvg';

export {
  ICONIFY_API, ICON_SETS, iconJsonUrl, svgFromIconJson,
} from '@/editor-v2/utils/iconSvg';
export const DEFAULT_ICON_PREFIX = 'lucide';

/** Prefixes the free-text search spans, as the Iconify search API expects them. */
export const SEARCH_PREFIXES = ICON_SETS.map((s) => s.prefix).join(',');

/** Full Iconify reference ("lucide:heart") for a name inside a collection. */
export function iconRefOf(prefix, name) {
  return `${prefix}:${name}`;
}

/** Bare icon name of a full reference, for labels and search matching. */
export function iconNameOf(ref) {
  const idx = ref.indexOf(':');
  return idx > 0 ? ref.slice(idx + 1) : ref;
}

/**
 * Parse a stored data-icon value into an Iconify {prefix, name}.
 * Legacy FontAwesome values ("fa-ticket") and empty input return null.
 */
export function parseIconRef(dataIcon) {
  if (!dataIcon || typeof dataIcon !== 'string') return null;
  const idx = dataIcon.indexOf(':');
  if (idx <= 0) return null; // no prefix separator (e.g. "fa-ticket")
  return { prefix: dataIcon.slice(0, idx), name: dataIcon.slice(idx + 1) };
}

// Moved to src/editor-v2/utils/iconSvg.js (Task 3, spec 2026-08-15
// divider/icon elements) so the canvas-side pick handler
// (useMediaAndContainerHandlers.ts#handleV2IconPick) can re-run the SAME
// normalization + sanitization on an incoming svg string instead of
// trusting the postMessage payload verbatim — see that file's own header
// comment for the full reasoning (why this needed to become ONE shared
// implementation, not two). This is now a pure re-export shim, same
// precedent as focalPointMath.js -> pointerPercent.js.
// eslint-disable-next-line import/prefer-default-export
export { normalizeIconSvg } from '@/editor-v2/utils/iconSvg';
